<app-financial-dashboard-chart></app-financial-dashboard-chart>